export default __webpack_public_path__ + "static/media/Institution.3abf3e16.svg";